module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA32"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.33.0.0.box.473.316.625.359.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.33.0.0.box.730.316.112.74.q.70"
    }
  }, [_vm._v("III")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.33.0.1.box.473.528.625.147.q.80"
    }
  }, [_vm._v("MY ARRIVAL AT MOABIT PRISON")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.33.1.0.box.190.871.1192.1227.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.33.1.0.box.190.871.1192.1227.q.60"
    }
  }, [_c('b', [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.1.0.0"
    }
  }), _vm._v("I")]), _vm._v("T SHOULD be understood that at the time I was taken by the Gestapo there had been no mass arrests of Jews. The Nazis were proceeding against them individually, and there was then no baiting of Jews to whet the Nazi appetite for greater game. But my historical sense warned me now that we were probably entering upon a program such as other governments in other times had instituted to conceal a larger purpose. The strained look I had met occasionally in the eyes of some of my Aryan friends had now a definite meaning. They were being whipped into shape to overcome their moral scruples against the great blood bath in which Hitler was to purge the German conscience. Slowly the faucets were being turned on, not only in Germany, but all over Europe, and I was soon to know that the Star of David was to become the symbol of shame, the mark of the great adultress who had robbed Germany of her manhood. All this in spite of the former German attitude, which had welcomed the Jews as citizens of a common country, to which the Jews, in turn, had given their fealty and devotion. My concern was the deeper because, as I looked back, the events which had occurred since the dark day when Hitler's forelock appeared over the political horizon began to unroll themselves in a pattern whose ultimate purpose could not be mistaken. In all this the"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.34.1.0.box.196.306.1192.99.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.0.0"
    }
  }), _vm._v("\narrest of the former U-boat commander. Pastor Martin Niemoeller, had a profound significance.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA33"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.34.1.0.box.194.306.1197.1839.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.1.1.box.194.415.1197.1730.q.60"
    }
  }, [_vm._v("After a few days that seemed an eternity of doubt and misgiving, I was informed that the attorney general of the District of Berlin had ordered that I be transferred to the Moabit prison. On the morning following this announcement a guard unlocked my cell and led me outside. The bright light made my eyes blink, but no time was given me to look around. I was hustled into a police car, much like the police cars one sees in New York. It was already so crowded that I had to be squeezed in. Both seats, which ran lengthwise of the car, were filled, so that there was hardly room for me to sit down, and presently the aisle between was filled with prisoners standing. The morning was very hot, and as it was a closed car we nearly suffocated. Most of the prisoners were very pale and looked anemic. In their faces I could read what was in store for me. Some of the prisoners, I learned from whispered conversation, were being taken to the People's Court, which was in the heart of Berlin, on one of the fashionable streets leading to the Tiergarten. These prisoners were charged with violating the new laws governing the transfer of money. Among them were two Roman Catholic priests, one of whom appeared old enough to be the other's father. Both had the appearance of highly cultivated men, and both manifested that ascetic calm which so often distinguishes the priests of the Catholic faith. They were standing, and presently the older man exhibited signs of suffering, probably from the effort to keep his equilibrium as well as from the suffocating condition of the car. I would have offered him my seat, but dared not make a move. However, the younger man placed an assisting hand under the other's elbow, and it was touching to observe the answering smile of gratitude and affection. Strange it was to see this devotion flowering in that air stinking with inhuman brutality.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.1.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA34"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.35.1.0.box.193.293.1198.1837.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.1.0.box.193.293.1194.375.q.70"
    }
  }, [_vm._v("The prisoners continued conversing in whispers, and I was able to catch that some of them had been before the People's Court many times, for the trials would last for several days, or even for weeks. But there was a measure of satisfaction in it for them, for they would have a better lunch than they would have had in prison. They would have frankfurters and potato salad.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.1.1.box.195.677.1194.801.q.60"
    }
  }, [_vm._v("One thing that surprised me was the general air of submissiveness, as if there was no question in the prisoners' minds concerning the justness of their arrest. I was not able to determine then whether this attitude was a consequence of their long stay in prison or due to the impression sedulously cultivated in the German mind that any action is correct which is based on a formal law. Whatever the cause, I could not discern any trace of a rebellious spirit among those about me. Both Jews and Gentiles were in the group, and all, apparently, had been accustomed to financial comfort, as I judged by their clothes and general appearance, and were evidently people of culture and refinement. This made their air of resignation all the more surprising to me. In me indignation at the injustice of it all was seething up through my doubts and fears.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.1.2.box.196.1488.1195.466.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.1.2.0"
    }
  }), _vm._v("At length we passed through the gates of Moabit prison. I had hardly descended from the car before I found myself in a room occupied by the prison administration. There I had to submit to a formal inquisition, and then had to undress myself so that my weight and height could be recorded. Then I was finger-printed and photographed, like any common criminal. Finally, I was taken to a bathroom to make myself clean for a loathsome cell. This was the formal routine for first arrivals at Moabit.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.1.3.box.196.1975.1193.155.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.1.3.0"
    }
  }), _vm._v("When I was dressed again, I was taken into the large central hall, where I was ordered to stand, with my back to the wall. I was deeply dejected, because the transfer to Moabit, I knew,"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.36.1.0.box.197.304.1194.153.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.0.0"
    }
  }), _vm._v("\nconfirmed the seriousness of the Gestapo's charge against me. In Moabit were confined those who were likely to be condemned to death or to imprisonment for life.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA35"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.36.1.0.box.194.304.1201.1837.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.1.1.box.195.468.1197.697.q.60"
    }
  }, [_vm._v("The hall, or room, was circular, and its ceiling was the ceiling for the whole building—a one-story affair. From this room stairways led to four galleries, one above the other. The corridors in front of the cell blocks were protected by iron balustrades. Each cell block had a guard. In the middle of the floor of the room was a large desk for the use of the chief of the guards. It was provided with a telephone, which rang almost incessantly. When the chief of guards answered, he would call out a prisoner's name to one of his assistants, who would look up his cell number, and then yell name and number to the guard on duty on the proper gallery and tell him to bring the prisoner down. It would be to see visitors or an attorney. The place seemed to be in constant turmoil.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.1.2.box.196.1175.1199.413.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.2.0"
    }
  }), _vm._v("Other prisoners were ranged along the wall on either side of me, eyes downcast, almost motionless, and as dejected as I. They were unshaven, and their clothes showed signs of long neglect. The guards, on the other hand, looked clean and healthy. They were a noisy lot, laughing loudly, gesticulating, and affecting a spirit of gaiety. The contrast between them and the silent prisoners affected my nerves, and every minute I felt as if I must break under the strain.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.1.3.box.194.1610.1197.531.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.3.0"
    }
  }), _vm._v("Finally, one of the guards led me up to a gallery, and locked me in a cell. The cell was slightly larger and somewhat brighter than the one I had occupied in Ploetzensee. It was newly painted, and the guard remarked on the fact facetiously as he turned the key. In Ploetzensee I had shared a cell with another prisoner, and I had resented the forced intimacy. Here, for some reason I did not know, I was alone, although Moabit prison was overcrowded. I wondered whether the solitary confinement was meant to be a privilege or a punishment. But the question did not bother me;"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.37.1.0.box.193.294.1195.533.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA36.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA36.w.1.0.0"
    }
  }), _vm._v("\nI was only too glad to be alone. I sat down on the only chair before a little wooden table, and buried my head in my hands. But I was too exhausted, too worn down by apprehension, to compose my thoughts. Two refrains hammered alternately on my brain: How will it end? What will become of my wife? Hitler's iron heel was making its impression in my soul. Perhaps to those who have been justly charged there is some consolation in the knowledge that their punishment is merited. But what consolation can come to the victims of injustice?")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA36"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.37.1.0.box.193.294.1202.1834.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.1.1.box.193.837.1195.586.q.60"
    }
  }, [_vm._v("After a long time there was the noise of keys, and the cell door was opened. A guard handed me a bowl filled with watery soup and a tiny piece of bread. It was my supper. I placed the food on the table, and left it untouched. By and by darkness shut me in, and I knew that the sun was setting. A hush fell over the prison, and from the far outside I could hear the subdued song of a nightingale. The notes aroused me. Birds still could sing! I listened until the song was done. Then I lay down on the straw mattress, through which I could feel the hardness of the iron cot. Sleep! Who could sleep after his whole world had disintegrated about him?")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.1.2.box.195.1432.1200.696.q.60"
    }
  }, [_vm._v("Yesterday was years away, and it would be years before the dawn. But, finally, day did peep into my cell. Soon afterwards a bell rang, and then came a guard bearing my breakfast of dry bread and muddy coffee. He informed me that prison routine required that I be taken again before the inquiring judge. I put the bread and coffee on the table, untouched, and waited. A burly guard came, unlocked the cell and ordered me out. But I knew the way. A long tunnel connects the prison with the criminal court of the District of Berlin, and I had often passed through it when I worked in the office of the District Attorney and had to visit prisoners in the course of my duties. Then I had looked upon prisoners as merely objects of the law, who could have no rights"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.38.1.0.box.202.306.1194.154.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.1.0.0"
    }
  }), _vm._v("\nuntil the law had been requited. Then law had been identified in my mind with justice. Now I was learning that law is too often the refuge of injustice.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA37"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.38.1.0.box.192.306.1205.1838.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.1.1.box.200.470.1197.481.q.60"
    }
  }, [_vm._v("I was horribly nervous, and found it difficult to keep up with the guard. He cuffed me on the ear, and I tried to hurry. Presently we were out of the tunnel, entering a corridor, from which we passed through several halls on our way to the anteroom of the criminal court. Judges and clerks were constantly passing and repassing, and I felt as if all eyes were on me—a former judge. Some I recognized, but they gave me only a fleeting glance of amused contempt. None addressed me, nor did the guard speak.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.1.2.box.201.961.1195.523.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.1.2.0"
    }
  }), _vm._v("We entered the antechamber, a long, narrow room, with one barred window, which looked out on a small yard. Opposite the door I entered was the door leading to the court room. A number of hard-wood chairs were ranged against the walls, and most of them were occupied by prisoners also awaiting inquisition. Among them was a professor of the famous Catholic seminary at Breslau. He had been arrested on a charge of high treason because of his support of the Catholic opposition to Nazism under the leadership of Cardinal Faulhaber of Munich.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.1.3.box.192.1505.1204.249.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.1.3.0"
    }
  }), _vm._v("Finally, my turn came, and the guard ushered me into the judge's chamber. I bowed to the man at the desk, and said, \"Good day.\" It was the usual perfunctory greeting, for Jews are not permitted to use the Nazi salutation, even if they wish to abase themselves.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.1.4.box.201.1774.1195.370.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.1.4.0"
    }
  }), _vm._v("The judge rose from his chair, and I immediately recognized a former acquaintance. It was Judge Walter. \"Heil Hitler,\" he said, and then, \""), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("A")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mtsgerichtsrat ")]), _vm._v("Walter is my name. Please be seated, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Herr ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Doktor")]), _vm._v(".\" He bowed slightly towards a chair in front of his desk, and I sat down. The courteous manner in which I was addressed surprised me, and I felt new hope swelling in my breast that here, at last, the case"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.39.1.0.box.194.294.1195.372.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA38.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA38.w.1.0.0"
    }
  }), _vm._v("\nagainst me would be gone into thoroughly and I would be immediately released. The National Socialist propaganda had always proclaimed that the Third Reich had not abandoned the principle of justice, and the tremendous swastika which Judge Walter wore did not seem to contradict my hope. While he searched for my papers on his desk, I had time to glance around the chamber.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA38"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.39.1.0.box.194.294.1197.1833.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.39.1.1.box.194.676.1196.746.q.70"
    }
  }, [_vm._v("It was a large square room, with three large windows on one side overlooking the street. The windows were barred. There were two doors, one leading to the waiting room from which I had just come, the other to a corridor, through which prisoners were taken out after the ordeal. At one side of the judge's desk was a small table, at which sat a stenographer. I knew that I would have to be careful in my replies, for I had heard that sometimes poorly educated prisoners were trapped into making false admissions when they failed to follow the rapid reading of the stenographic report of the hearing, which always followed the inquisition. This procedure was a violation of the old law, which expressly prescribed that prisoners should have the opportunity to read their statements before signing them.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.39.1.2.box.196.1433.1194.422.q.60"
    }
  }, [_vm._v("With the papers in front of him. Judge Walter took my personal history, apologizing that it was only a matter of routine. Then his manner changed abruptly. He stiffened himself in his chair, and said sharply, \"And now, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Herr ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Doktor")]), _vm._v(","), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }), _vm._v("let us come to the business which brings you here. You have committed an attempt at high treason by declaring in your lectures before an audience of students that our Fuehrer and our Reich should be destroyed.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.39.1.3.box.197.1866.1193.152.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38.w.1.3.0"
    }
  }), _vm._v("\"But, Herr "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Amtsgerichtsrat")]), _vm._v("\" I exclaimed in surprise, \"there is not the slightest evidence that I am guilty of attempted high treason. I am only charged with it.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.39.1.4.box.197.2028.1194.99.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38.w.1.4.0"
    }
  }), _vm._v("\"Yes,\" Judge Walter replied, an evil smile on his lips, \"there is no so-called evidence against you yet. But we do not"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.40.1.0.box.200.304.1195.155.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA39.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.0.0"
    }
  }), _vm._v("\nstumble over such threads. Besides, I find that the Gestapo has not gone into your case as methodically as usual. Why didn't they make you confess your crime?\"")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA39"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.40.1.0.box.193.304.1206.1832.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.1.box.193.468.1204.263.q.50"
    }
  }, [_vm._v("Why hadn't they made me confess? Why hadn't they tortured me? The full implication of what Judge Walter meant struck me like a sledge hammer. It knocked out my last vestige of faith in the justice of Prussian law and Prussian judges.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.2.box.252.740.1141.44.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.2.0"
    }
  }), _vm._v("I must have looked my utter astonishment at his callousness.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.3.box.200.793.1196.319.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.3.0"
    }
  }), _vm._v("But he merely tapped the desk with his long fingers, and said, \"The Gestapo has handled your case with unbelievable carelessness. We will have to start from the beginning again. I cannot understand why only one of your students testified against you. But we will see. This is enough for one day. You will hear from us again.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.4.box.202.1121.1196.262.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.4.0"
    }
  }), _vm._v("He continued drumming the desk with his fingers while the clerk transposed his notes. I sat silent and bewildered for a while, and then summoned courage to ask Judge Walter how long it would take him to find out the truth of the charge against me.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.5.box.200.1392.1197.209.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.5.0"
    }
  }), _vm._v("\"God knows,\" he answered, \"God knows. I am afraid you will have to be patient, unless, of course, you wish to make a confession. But you wouldn't do that, I suppose. However, don't worry. We will take good care of you.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.6.box.201.1610.1198.369.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.6.0"
    }
  }), _vm._v("The clerk read the report of the hearing to me, and I signed it. Then Judge Walter pressed a button, and a guard came in. As I was led away, Judge Walter turned his back. Through the tunnel I was escorted back to my cell. The day was already far gone, and I resigned myself to another long night of contemplation of the circumstances which had brought me from the bench to a criminal's lodging.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.7.box.202.1988.1196.148.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.7.0"
    }
  }), _vm._v("My cell was approximately seven steps in length and four steps in width, so that there was little room to pace up and down when I was restless, which was the case most of the"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.41.1.0.box.190.293.1192.627.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA40.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.0.0"
    }
  }), _vm._v("\ntime. Each cell was provided with an iron cot, fitted to the wall, from which it was let down when in use; a little wood table, and a wood chair. On the wall was a small shelf, on which the prisoner could place the extra food which he bought with his own money. There was also a toilet, and we had a small bowl in which to wash face and hands. If two prisoners occupied a cell, an extra chair was provided, and one had to sleep on the floor, on a mattress. The mattresses were very hard, and both cot and mattresses were alive with bedbugs. There was one small window, very high, and difficult to reach when it had to be opened and cleaned. It was barred on the outside.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA40"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.41.1.0.box.190.293.1197.1825.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.1.1.box.193.942.1190.150.q.60"
    }
  }, [_vm._v("I was still awake when the guard rattled at my cell door the next morning and formally introduced me to prison routine, which I might as well describe now.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.1.2.box.192.1101.1195.854.q.60"
    }
  }, [_vm._v("In Moabit the day started at 7 o'clock, with the ringing of a bell, which was the signal for the prisoners to get up and dress (which was not a long operation, as there was no change of clothing). Fifteen minutes later the cells were unlocked by the guards on duty, and the prisoners put out their pitchers, which were filled with water by trusties. Then we washed ourselves as best we could, and a quarter of an hour later breakfast was handed in. This consisted of a bitter black liquid, without sugar or milk, which was called \"coffee,\" and a piece of \"rye\" bread, which was so badly prepared that frequently it made the prisoners ill. This bread was baked in the prison kitchen. It is doubtful that it contained any flour at all. When it was fresh it was too soggy to be eaten. But prisoners were sometimes so hungry that they would wolf it down and then become sick. It took me a long time to become accustomed to it, and often it gave me a stomach ache.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.1.3.box.193.1965.1190.153.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.3.0"
    }
  }), _vm._v("After breakfast we had to make up our \"beds\" and clean our cells. The \"beds\" had to be made in military fashion, which I always found difficult to do. Often it got me into"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.42.1.0.box.193.293.1194.588.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA41.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA41.w.1.0.0"
    }
  }), _vm._v("\ntrouble with the guards, and I would have to make the \"bed\" over again. After the \"beds\" were done, we swept the floor. On Saturdays, after the recreation, or exercise, hour, we had to clean our cells very thoroughly. Guards brought in brooms, pails and buckets, and we had to go to the gallery to fill the pails. We scrubbed the floors and washed the windows. As the windows are very high and I am short, washing my window was very difficult for me, and I was frequently harshly scolded for not doing it properly. Later on, I often met Pastor Niemoeller when we went to the gallery to fill our pails, and we would greet each other in passing.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA41"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.42.1.0.box.191.293.1199.1831.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.42.1.1.box.191.891.1199.1233.q.60"
    }
  }, [_vm._v("About eight-thirty the bell rang for the recreation hour. A few minutes later the guards would arrive and unlock our cells. Then each prisoner stepped out and waited in front of his cell door. Another bell rang, and we stepped forward and turned to the right, and then marched in military formation down to the yard. The recreation continued an hour or sometimes longer. I shall tell about that later. After we had been exercised, we were marched back to our cells. Lunch was brought to us at noon. It consisted of watery soup and a piece of the same sort of awful bread we had for breakfast. On Sundays, however, we received two ounces of pork and a small dish of potatoes in addition. At 5 o'clock the guards brought us our supper—another piece of bread, a little soup, thinner than that we had for lunch, and sometimes tea, which we all thought was made from the leaves of the linden tree in the yard. We always had to hurry through supper (not that it would have taken long to eat it) because the guards would return in a few minutes to take away our plates and other utensils. Then we were locked up for the night. Under the old law, which the Nazis had not changed at this time, prisoners being held for trial were not made to work. However, under the restraints imposed by the Nazis, this turned out to be a hardship, for, except for the daily hour of"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA42.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.43.1.0.box.202.295.1192.154.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA42.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA42.w.1.0.0"
    }
  }), _vm._v("\nexercise, prisoners had nothing to occupy their minds or hands. They could think only of themselves and the plight they were in.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA42"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.43.1.0.box.193.295.1203.1833.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA42.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.43.1.1.box.200.459.1195.522.q.60"
    }
  }, [_vm._v("True, there was a library in Moabit, but prisoners were allowed to read only National Socialist literature and newspapers. Relatives were not allowed to bring in books or magazines. I remember that I once asked my wife when she was visiting me to bring me Ranke's "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("History ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Reformation ")]), _vm._v("from my library at home. But she was not allowed to do so because Ranke's conception of history did not conform with that of the National Socialists. Since, naturally, Nazi literature did not appeal to the prisoners, most of them did not read at all.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA42.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.43.1.2.box.193.1003.1203.1070.q.60"
    }
  }, [_vm._v("Ironically, there was one exception to the general ban. There was a copy of the New Testament in every cell. But the Old Testament was "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("verboten. ")]), _vm._v("Afterwards, the New Testament, too, was relegated to the ash heap. Religious services also were permitted when I went to Moabit. They were held every second Sunday, each creed being allowed to have its own pastor. Even the Jews could have a rabbi attend them. The Christian services were held in a small chapel and the Jewish services in a room provided for the purpose. Also pastors, priests, and rabbis were allowed to make personal calls on their followers in prison. In Sachsenhausen, however, I learned from prisoners who followed me from Moabit that these services were finally prohibited. I was a regular attendant at the Jewish services, but found the rabbi rutted in a predicament. Because of the possible effect on himself and the Jewish prisoners he feared to preach a sermon directed towards their present needs, and merely repeated sermons he used to preach to criminals when he was employed as a prison chaplain. \"You know,\" he said to me one day, \"in Hitler's eyes every Jew is a born criminal.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA42.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.43.1.3.box.252.2084.1142.44.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42.w.1.3.0"
    }
  }), _vm._v("During my first days in Moabit I gave the other prisoners"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA43.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.44.1.0.box.194.305.1202.1838.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA43.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA43.w.1.0.0"
    }
  }), _vm._v("\nlittle attention, being too engrossed with my own thoughts. But presently some of them began talking with me, asking where I had come from, what I was charged with, how I had been treated, etc. Most of them, I observed, had the same appearance as the prisoners I had met in the police car. They were worn and faded semblances of their former selves. One of the first questions was how had I found the food at Ploetzensee, and some who had been confined in that prison inquired about certain of the guards. I was amazed at the pettiness of the inquiries and the general conversation. Later on, I learned that long confinement narrows the mental horizon and curtains the mind. Except when a prisoner was taken to a hospital, or was removed to be seen no more, there was little to talk about, and petty details assumed a large importance. Having been a judge myself, who had sentenced men to prison, I now had the opportunity to observe the practical consequences of a prison sentence. I found that it means much more than the mere deprivation of liberty for a stated time. It brings a change in the mental state which has serious results. Men become childish, inclined to quarrel over trifles. The Moabit guards were unable to understand this phenomenon, and they treated the prisoners with coarse brutality, laughing contemptuously when, for instance, one quarreled because another had gotten a larger potato or a bigger piece of bread. Fearing that I too might become reduced to this condition, I determined to watch myself carefully. I occupied myself with plans to procure my discharge. I tried to think of a way by which I could bring my protest to the authorities. When he called on me I attempted to induce my attorney to make a formal protest to the attorney general. But he refused, on the ground that he would not dare such an effort in a political case. He reminded me that I had been committed on a charge of attempted high treason. When all")]), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA44.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.45.1.0.box.193.295.1188.100.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA44"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA44.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.0.0"
    }
  }), _vm._v("\nrecourse had failed and I had come fully to realize that I was helpless, I decided on a hunger strike.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA43"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.44.1.0.box.194.305.1202.1838.q.60"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA44"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.45.1.0.box.190.295.1197.1826.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA44.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.45.1.1.box.190.406.1192.584.q.60"
    }
  }, [_vm._v("One morning I refused to accept the food given to me, and I remained firm against the appeals of hunger. But every morning I drank a few drops of water. During the first four days hunger gnawed at my stomach, and it felt as if it were being compressed in a vise. On the fourth day I felt very ill, and I had to pull myself together and summon all my latent resources to withstand the desire to eat. To make sure of myself, I did not even accept the food, and the guard took it away. But that evening I could not resist the temptation to accept a piece of bread. But I did not eat it; I merely smelled it. Then I threw it away.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA44.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.45.1.2.box.193.1000.1194.1066.q.60"
    }
  }, [_vm._v("For the first time, I managed to sleep that night. When I awoke the next morning my hunger had abated. From that time on I was without appetite. I felt myself growing weaker and weaker, and fell into a sort of apathy, which was by no means unpleasant, but strangely sweet. I thought it would be pleasant to die like that. It would be like floating away. I was becoming light-headed. Strangely, the remembered scent of linden trees came to me, and I heard again the singing of the nightingale. Several times during my period of self-imposed starvation the prison doctor came to see me and urged me to eat. But I declined, saying that I would not eat until justice had been done me. He shrugged his shoulders, and said, \"You fool, don't you know that justice doesn't exist in Germany any more? I must inform you that hunger strikes are forbidden and are considered to be resistance to the State. If I should report you, you would immediately be brought before a special court, which would condemn you to death without further ado. Be reasonable, and don't make unnecessary trouble. I am speaking for your own good.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA44.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.45.1.3.box.244.2076.1138.45.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.3.0"
    }
  }), _vm._v("He did not report me. Instead, on the sixteenth day of my"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA45.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.46.1.0.box.200.293.1193.371.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA45"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA45.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA45.w.1.0.0"
    }
  }), _vm._v("\nordeal he had me brought down to his office, where he took my weight. I had lost sixteen kilograms, almost thirty-six pounds in American weight. The doctor ordered me to the prison hospital. I have often wondered since how it came about that Dr. — was serving in Moabit prison, and why he took an interest in me and was kind to me. Evidently he had not yet been poisoned with the Nazi virus.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA45.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA45"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.46.1.0.box.191.293.1206.1832.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA45.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.46.1.1.box.191.674.1206.1396.q.60"
    }
  }, [_vm._v("The hospital in Moabit is, or was at that time, the largest and best prison hospital in Prussia. Prisoners who were seriously ill and could not receive proper treatment in their own prison hospitals were brought to Moabit for treatment. But even the Moabit hospital did not have the equipment of a normal hospital, and prisoner patients of the older regime who needed a major operation were transferred to private hospitals. This practice was discontinued after Hitler came to power. The result of this was that during the almost eight months I stayed in the Moabit hospital I knew of no major operation that was successful. Patients died either on the operating table or a short time afterward for lack of capable doctors, of necessary instruments, and of proper care. The head doctor was a Roman Catholic, and the only one who behaved like a human being. But even he was restricted by the regulations and the lack of proper equipment and assistance. He confided to me one day that he was not a competent surgeon, but was required to perform operations nevertheless. But most of the operations were performed by a young surgeon, a fervent Nazi, who had had no experience whatever. As he considered the patients beneath him, he was heedless of what happened to them after he had used his knife. For instance, one day a prisoner was brought in who had cut his jugular vein in an attempt at suicide, and the young Nazi surgeon exclaimed, \"Why didn't he finish the job while he was about it?\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA45.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.46.1.2.box.250.2081.1146.44.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA45.w.1.2.0"
    }
  }), _vm._v("Most of the people imprisoned after the beginning of"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.47.1.0.box.194.295.1194.1073.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.1.0.0"
    }
  }), _vm._v("\nHitler's regime were political prisoners. I estimate that the total number of prisoners when I was one of them was about one and a half million, of which not more than two hundred thousand had been arrested for non-political reasons. In addition, there were approximately one million men in the concentration camps. The Nazis were bent on destroying the least vestige of opposition. In many cases the charges consisted of reading illicit newspapers, listening to forbidden radio broadcasts, and criticizing the new regime. One case I remember especially. A German working man had visited Switzerland. There he had gone to a reading room and read Swiss papers printed in German. He was observed by a Gestapo agent. He was arrested immediately on re-entering Germany, and was sentenced to serve seven years at hard labor. In the course of time he became ill, and was brought to Moabit hospital for a stomach operation. He died on the operating table. The body was not returned to the family for burial, but cremated. That was the general rule. Bodies were cremated without rite or service of any kind. A little carton of ashes handed to the family was due notice of death.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA47"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA47.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA47.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA46"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.47.1.0.box.193.295.1195.1821.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.1.1.box.193.1379.1195.737.q.70"
    }
  }, [_vm._v("When I entered the hospital it had become little better than a chamber of horrors. Purification of the racial strain had become one of the cardinal objectives of the Nazi regime, this being in keeping with the new biological theory that the Creator had especially endowed the German people and that crime was a symptom of tainted blood. To put this theory into practice, judges were empowered to sentence people convicted of certain offenses to sterilization or emasculation. Among the offenses for which this drastic penalty could be imposed were violations of the law regulating the transfer of money, of the racial law, and of certain political laws. The racial law covered sex crimes and even innocent relations between Jews and Aryans. It was not long before the list was extended to cover even trivial offenses.")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA47"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.48.1.0.box.193.304.1203.1838.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA47.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.48.1.0.box.193.304.1203.1024.q.70"
    }
  }, [_vm._v("In Moabit I met many victims of this terrible practice. Many of them had been convicted only of some petty offense, which, in a large number of cases, was the first. Nevertheless, the doctors employed by the courts to examine prisoners had declared that they were habitual criminals and that it would be a waste of time merely to imprison or otherwise punish them in accordance with the older laws. Therefore, they were ordered to be sterilized or emasculated to prevent their bringing \"criminal\" offspring into the world. Crime against sex included any sort of disorderly conduct towards women, so that, for instance, a drunken man who accosted a woman on the street was liable to be subjected to the new punishment. What struck me most was the fact that the majority of men forced to undergo the operation belonged to the underprivileged class. I could not help reflecting sometimes that if there had been such a law in Austria some sixty years ago there might not have been a Hitler. His family tree would not have passed the test he has imposed on others.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA47.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.48.1.1.box.200.1339.1196.748.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA47.w.1.1.0"
    }
  }), _vm._v("There were five or six emasculation or sterilization operations every day, and among all I met who had undergone this cruel punishment were very few of the better social class. These few had been convicted, not of sex crimes, but of violations of the political laws. If Hitler could not completely stifle opposition in one generation, he might, at least, prevent it from germinating in the next. A saddening commentary is that most of the victims had been in perfect physical health, men who might have become good German fathers if they had been able to live under better social conditions. Of course, there were fathers among the unfortunates, whose sons and grandsons may remember this senseless, vindictive sadism when the terrible hour of reckoning comes.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA47.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.48.1.2.box.250.2097.1142.45.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA47.w.1.2.0"
    }
  }), _vm._v("Sometimes prospective victims feared that the operation"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA48.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.49.1.0.box.193.294.1196.803.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA48"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA48.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA48.w.1.0.0"
    }
  }), _vm._v("\nwould be fatal, and would inquire of the trusties whether there was such danger. But the only reply was some inexpressible vulgarity and that they would not even feel the knife. And, indeed, during the first weeks of my stay in the hospital, the operations were successful. Then, suddenly, came rumors that men were dying on the operating table, that they were unable to withstand the ether. This surprised me as much as it shocked me, and I realized that if there were any truth in the rumors the deaths could not be due to accident, but must be due to design. I did not dare question the head doctor, though he often stopped to talk with me, but I noticed that he looked very disturbed, and this confirmed my suspicion. Even the trusties, who often talked with me frankly, told me to mind my own business when I attempted to question them discreetly.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA48.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA48.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA48.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA48"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.49.1.0.box.193.294.1196.1834.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA48.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.49.1.1.box.194.1108.1195.586.q.60"
    }
  }, [_vm._v("Finally, a gift of some of the additional food I was able to buy induced one of the trusties to talk. He told me that some of the men who supposedly had been sentenced to emasculation had really been marked for death because doctors had said that they were not fit to live. They were used, therefore, to test new gases, the trusty told me. But the tests had to be carried out in secret, because, at that time at least, there was no law permitting so-called \"mercy\" killings. So when a man died under one of these tests, it was announced that he had succumbed either to the operation (simple as it is) or to the ether.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA48.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.49.1.2.box.193.1704.1195.424.q.70"
    }
  }, [_vm._v("Of course, these stories spread among men waiting for the operation, and it was horrible to hear their ravings and struggles when they were being taken into the operating room. Some of them became violently insane while waiting for the ordeal, and these were put in straitjackets and locked in the cellar of the hospital until the doctors were ready for them. Even many of those who preserved their senses had to be placed in strait-jackets so that the orderlies"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA49.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.50.1.0.box.194.291.1193.208.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA49"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA49.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA49.w.1.0.0"
    }
  }), _vm._v("\ncould get them on the operating table. To dwell longer on this tremendous tragedy would, perhaps, overstrain the emotion of my readers, and further description could not add to what the imagination can conceive.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA49.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA49"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.50.1.0.box.191.291.1200.1830.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA49.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.50.1.1.box.193.509.1195.371.q.60"
    }
  }, [_vm._v("As for myself during this time, I spent most of the first weeks in bed. I was fed with grape sugar injected in my arm and liquid food through a tube in my nose. Why such care was taken of me I do not know, and I can only hazard the guess that some influence in my behalf was being exercised outside the prison walls. Gradually, I became less nervous, and began to regain my strength.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA49.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.50.1.2.box.192.890.1199.1015.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA49.w.1.2.0"
    }
  }), _vm._v("The long monotony was relieved when the prior of a famous monastery, whom I had met and talked with before being removed to the hospital, was brought into the cell I was occupying. He had been sentenced to ten years at hard labor because his monastery had continued to pay interest on a loan borrowed in Holland. He had come down with a bad case of rheumatism, which made it impossible for him to move without suffering great agony. Day and night he lay almost motionless on his back. But in spite of his condition, he displayed marvelous fortitude and uttered no word of complaint. He took an interest in me, and admonished me to take food in order to keep myself alive. It was not for me to decide whether I should live or die, he said, and he was so convincing that I began accepting food again. My long stay in prison had helped me to adjust myself in some degree, and under the urging of my new friend I decided to hold my head up and not give way to despair. I had made such decision before, but sometimes my powers of resistance gave way.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA49.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.50.1.3.box.191.1916.1196.205.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA49.w.1.3.0"
    }
  }), _vm._v("One day I was permitted to see my wife, the first time since my arrest. Escorted by a guard, she was brought to my bed, and we were allowed fifteen minutes in which to talk, with the guard standing by the whole time. She was wan with"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA50.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.51.1.0.box.193.294.1195.360.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA50"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA50.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA50.w.1.0.0"
    }
  }), _vm._v("\nfear and worry, and it came to me that she was under greater stress than I, for I knew what each day would bring forth, that existence could hardly hold more terror for me than it held now, while she could put no rein on her imagination. When she was taking her leave, she wanted to kiss me. But it was against the prison rules. She could only give me her hand.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA50.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA50.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA50.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA50"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.51.1.0.box.193.294.1197.1832.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA50.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.51.1.1.box.193.675.1197.1234.q.60"
    }
  }, [_vm._v("Later on, when I was better, I was transferred to a ward, where there were about twenty other prisoners undergoing various treatments. Some of them had been brought from provincial penitentiaries because their local prison hospitals were not sufficiently equipped to care for them. Among them were men who had spent the last twenty years behind prison walls on convictions varying from robbery to manslaughter. There were Communists, too, who had been arrested for their political activities. So there were occasional discussions about Communism. To my great surprise, the common criminals expressed the utmost sympathy for Communism, although, in private conversations, they had told me that they had resorted to crime because they were dissatisfied with their earnings, which were by no means meager, for they were all artisans of more than average skill. Still, they insisted on being victims of the social order and saw in Communism a remedy for their supposed social ills. \"As common criminals we cannot be members of the Communist party,\" one of them told me, \"but we are in full sympathy with it.\" I often argued that society had given them a very good chance to make a decent living, and one day got such a severe beating for my pains that I had to be transferred back to my bed.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA50.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.51.1.2.box.197.1920.1191.140.q.60"
    }
  }, [_vm._v("The prior was still there. I told him of my experience in the ward, and complained of having had to live in such close contact with criminals.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA50.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.51.1.3.box.248.2082.1140.44.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA50.w.1.3.0"
    }
  }), _vm._v("\"Be patient, my son,\" he replied. \"Not all of those we call"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA51.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.52.1.0.box.190.290.1195.154.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA51"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA51.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA51.w.1.0.0"
    }
  }), _vm._v("\ncriminals are really criminally inclined. I have learned that some of them have more character and heart than those who now rule our country.\"")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA51.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA51"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.52.1.0.box.190.290.1197.578.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA51.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.52.1.1.box.192.453.1195.415.q.60"
    }
  }, [_vm._v("After almost eight months in the hospital, the doctor said I was able to resume prison routine, and I was sent back to the prison and put in the same cell block that I had been in before. This time I had a cell mate. Through the long night I heard his supplicating sighs and nervous shufflings. I wondered again about the future, and fought against the terror that once more clutched at my heart. It is well for me that the veil was not lifted.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA52"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA52.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA52.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55d9e4be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0011.vue
// module id = 72
// module chunks = 0